import React from "react";
import { useTranslation } from "react-i18next";
import "./Footer.css";

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer id="contact">
      <div className="footer-inner">
        <div className="footer-brand">
          <a href="/">
            <img src="/img/logo_negative.png" alt="Ametros Logo" />
          </a>
          <p>{t("footer.brandDescription")}</p>
          <div className="tagline-line">
            <span>{t("hero.tagline.connect")}</span>
            <span className="dot"></span>
            <span>{t("hero.tagline.integrate")}</span>
            <span className="dot"></span>
            <span>{t("hero.tagline.perform")}</span>
          </div>
        </div>
        <div className="footer-col footer-contact">
          <h4>{t("footer.contact")}</h4>
          <p>{t("footer.companyName")}</p>
          <p>{t("footer.companyAddress")}</p>
          <p>
            <a href={`mailto:${t("footer.email")}`} className="email">
              {t("footer.email")}
            </a>
          </p>
        </div>
        <div className="footer-col footer-contact-add">
          OIB: 94935086860
          <br />
          MB: 05441633
          <br />
          MBS: 081380208
          <br />
          IBAN: HR2323600001102935837
          <br />
          SWIFT: ZABAHR2X
        </div>
        <div className="footer-col footer-contact-add">
          <span>{t("footer.companyDetails")}</span>
        </div>
      </div>

      <div className="footer-bottom">
        <span>{t("footer.copyright")}</span>
        <span>{t("footer.tagline")}</span>
      </div>
    </footer>
  );
};

export default Footer;
